module.exports = _.toUpper;